import React, { useState, useEffect } from 'react';
import CustomSelect from '../customSelect/customSelect';
import OrganisationServices from "../../../services/organisation"
import { useNavigate } from 'react-router-dom';
import apiService from '../../../services/apiService';
import Select from 'react-select';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';
import dayjs from 'dayjs';

const EditOrgnisation = ({ orgData, onClose }) => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedCertificateImage, setSelectedCertificateImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [org_name, setOrgName] = useState('');
    const [org_size, setOrgSize] = useState('');
    const [org_sector, setOrgSector] = useState('');
    const [org_url, setOrgUrl] = useState('');
    const [org_address, setOrgAddress] = useState('');
    const [org_city, setOrgCity] = useState('');
    const [org_state, setOrgState] = useState('');
    const [org_pincode, setOrgPincode] = useState('');
    const [contact_name, setContactName] = useState('');
    const [contact_email, setContactEmail] = useState('');
    const [contact_mobile, setContactMobile] = useState('');
    const [contact_designation, setContactDesignation] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [contract_start_date, setContactStartDate] = useState('');
    const [contract_end_date, setContactEndDate] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [selectedOrgSize, setSelectedOrgSize] = useState('');
    const [selectedSector, setSelectedSector] = useState('');
    const [photo, setPhoto] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    const [selectedCertificateFile, setSelectedCertificateFile] = useState();
    const [file, setFile] = useState('');
    const [certificateFile, setCertificateFile] = useState('');
    const navigate = useNavigate();
    const [entityInput, setEntityInput] = useState('');
    const [entities, setEntities] = useState([]);
    const [branchInput, setBranchInput] = useState('');
    const [branches, setBranches] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [selectedShowCity, setSelectedShowCity] = useState('');
    const [isFetchingCities, setIsFetchingCities] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [plansList, setPlansList] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState('');
    const [selectedShowPlan, setSelectedShowPlan] = useState('');
    const [isFetchingPlans, setIsFetchingPlans] = useState(false);
    const [loader, setLoader] = useState();
    const [step, setStep] = useState(1);


    useEffect(() => {
        handleCity();
        handlePlans();
        if (orgData) {
            console.log("orgData.org_city", orgData.org_city);
            setOrgName(orgData.org_name || '');
            setSelectedOrgSize(orgData.org_size || '');
            setSelectedSector(orgData.org_sector || '');
            setOrgUrl(orgData.org_url || '');
            // Parse entities: if it's a string (comma-separated), split it; if it's an array, use it; otherwise empty array
            if (orgData?.entities) {
                if (Array.isArray(orgData.entities)) {
                    setEntities(orgData.entities);
                } else if (typeof orgData.entities === 'string' && orgData.entities.trim() !== '') {
                    // Split comma-separated string and trim whitespace from each entity
                    const entitiesArray = orgData.entities.split(',').map(entity => entity.trim()).filter(entity => entity !== '');
                    setEntities(entitiesArray);
                } else {
                    setEntities([]);
                }
            } else {
                setEntities([]);
            }
            
            // Parse branches: if it's a string (comma-separated), split it; if it's an array, use it; otherwise empty array
            if (orgData?.branches) {
                if (Array.isArray(orgData.branches)) {
                    setBranches(orgData.branches);
                } else if (typeof orgData.branches === 'string' && orgData.branches.trim() !== '') {
                    // Split comma-separated string and trim whitespace from each branch
                    const branchesArray = orgData.branches.split(',').map(branch => branch.trim()).filter(branch => branch !== '');
                    setBranches(branchesArray);
                } else {
                    setBranches([]);
                }
            } else {
                setBranches([]);
            }
            
            setOrgAddress(orgData.org_address || '');
            setSelectedCity(orgData.org_city || '');
            setSelectedShowCity([{ value: orgData.org_city, label: orgData.org_city, state: orgData.org_state }]);
            setSelectedState(orgData.org_state || '');
            setOrgPincode(orgData.org_pincode || '');
            setSelectedPlan(orgData.plan_id || '');
            setContactName(orgData.contact_name || '');
            setContactEmail(orgData.contact_email || '');
            setContactMobile(orgData.contact_mobile || '');
            setContactStartDate(orgData.contract_start_date || '');
            setContactEndDate(orgData.contract_end_date || '');
            setContactDesignation(orgData.contact_designation || '');
            setFile(orgData.org_image || ''); // Assuming image URL is provided
            setCertificateFile(orgData.org_logo || ''); // Assuming image URL is provided
        }
    }, []);

    useEffect(() => {
        if (plansList.length > 0 && orgData?.plan_id) {
            const selectedPlanOption = plansList.find(plan => plan.value === orgData.plan_id);
            if (selectedPlanOption) {
                setSelectedShowPlan(selectedPlanOption);
            }
        }
    }, [plansList, orgData]);


    const orgSizeOptions = [
        { value: '0 - 10', label: '0 - 10' },
        { value: '11 - 100', label: '11 - 100' },
        { value: '101 - 500', label: '101 - 500' },
        { value: '501 - 1000', label: '501 - 1000' },
        { value: '1000+', label: '1000+' },
    ];

    const sectorOptions = [
        { value: 'Agriculture', label: 'Agriculture' },
        { value: 'Automotive', label: 'Automotive' },
        { value: 'Banking', label: 'Banking' },
        { value: 'Biotechnology', label: 'Biotechnology' },
        { value: 'Chemicals', label: 'Chemicals' },
        { value: 'Construction', label: 'Construction' },

        { value: 'Consulting', label: 'Consulting' },
        { value: 'Consumer Goods', label: 'Consumer Goods' },
        { value: 'Education', label: 'Education' },
        { value: 'Energy', label: 'Energy' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'Entertainment', label: 'Entertainment' },

        { value: 'Environmental', label: 'Environmental' },
        { value: 'Fashion', label: 'Fashion' },
        { value: 'Finance', label: 'Finance' },
        { value: 'Food & Beverage', label: 'Food & Beverage' },
        { value: 'Government', label: 'Government' },
        { value: 'Healthcare', label: 'Healthcare' },

        { value: 'Hospitality', label: 'Hospitality' },
        { value: 'Information Technology (IT)', label: 'Information Technology (IT)' },
        { value: 'Insurance', label: 'Insurance' },
        { value: 'Legal', label: 'Legal' },
        { value: 'Manufacturing', label: 'Manufacturing' },
        { value: 'Marketing & Advertising', label: 'Marketing & Advertising' },

        { value: 'Media', label: 'Media' },
        { value: 'Nonprofit', label: 'Nonprofit' },
        { value: 'Pharmaceuticals', label: 'Pharmaceuticals' },
        { value: 'Real Estate', label: 'Real Estate' },
        { value: 'Retail', label: 'Retail' },
        { value: 'Telecommunications', label: 'Telecommunications' },

        { value: 'Transportation', label: 'Transportation' },
        { value: 'Travel & Tourism', label: 'Travel & Tourism' },
        { value: 'Utilities', label: 'Utilities' },
        { value: 'Other', label: 'Other' },
    ];

    const handleCity = (searchQuery) => {
        setIsFetchingCities(true);
        const token = apiService.getAuthToken();
        apiService.get(`get-cities?city=${searchQuery || ''}`, token)
            .then((response) => {
                const transformedCities = response.data.map(city => ({
                    label: city.name,
                    value: city.name,
                    state: city.state_name
                }));
                setCitiesList(transformedCities);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsFetchingCities(false);
            })
    }

    const handlePlans = () => {
        setIsFetchingPlans(true);
        const token = apiService.getAuthToken();
        apiService.get('get-organization-plans', token)
            .then((response) => {
                const transformedPlans = response.data.map(plan => ({
                    label: plan.planName,
                    value: plan.planId,
                    details: plan
                }));
                setPlansList(transformedPlans);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsFetchingPlans(false);
            })
    }

    useEffect(() => {
        handleCity(searchQuery);
    }, [searchQuery]);

    const handleInputChange = (event, { action }) => {
        const searchTerm = event;
        // Fetch cities only when the search query length is greater than or equal to 3 characters
        if (searchTerm?.length >= 3) {
            setSearchQuery(searchTerm);
        }
    };

    const handleCityChange = (selectedOption) => {
        console.log("selectedOption", selectedOption);
        setSelectedShowCity(selectedOption)
        setSelectedCity(selectedOption.value);
        setSelectedState(selectedOption.state);
    };

    const handlePlanChange = (selectedOption) => {
        setSelectedShowPlan(selectedOption);
        setSelectedPlan(selectedOption.value);
    };

    const handleOrgSizeChange = (value) => {
        setSelectedOrgSize(value);
    }

    const handleSectorChange = (value) => {
        setSelectedSector(value);
    }

    const handleAddEntity = () => {
        if (entityInput.trim() !== '') {
            const trimmedInput = entityInput.trim();
            // Check if entity already exists (case-insensitive)
            if (!entities.some(entity => entity.toLowerCase() === trimmedInput.toLowerCase())) {
                const updatedEntities = [...entities, trimmedInput];
                setEntities(updatedEntities);
                console.log('Added entity. New entities:', updatedEntities);
            } else {
                console.log('Entity already exists:', trimmedInput);
            }
            setEntityInput('');
        }
    };

    const handleRemoveEntity = (index) => {
        const newEntities = [...entities];
        const removedEntity = newEntities[index];
        newEntities.splice(index, 1);
        setEntities(newEntities);
        console.log(`Removed entity: "${removedEntity}". Remaining entities:`, newEntities);
    };

    const handleAddBranch = () => {
        if (branchInput.trim() !== '') {
            const trimmedInput = branchInput.trim();
            // Check if branch already exists (case-insensitive)
            if (!branches.some(branch => branch.toLowerCase() === trimmedInput.toLowerCase())) {
                const updatedBranches = [...branches, trimmedInput];
                setBranches(updatedBranches);
                console.log('Added branch. New branches:', updatedBranches);
            } else {
                console.log('Branch already exists:', trimmedInput);
            }
            setBranchInput('');
        }
    };

    const handleBranchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddBranch();
        }
    };

    const handleRemoveBranch = (index) => {
        const newBranches = [...branches];
        const removedBranch = newBranches[index];
        newBranches.splice(index, 1);
        setBranches(newBranches);
        console.log(`Removed branch: "${removedBranch}". Remaining branches:`, newBranches);
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setContactEmail(newEmail);
        validateEmail(newEmail);
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(email);
        if (!isValid) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
    };

    const handlePhoneChange = (e) => {
        const newPhoneNumber = e.target.value;
        setContactMobile(newPhoneNumber);
        validatePhone(newPhoneNumber);
    };

    const validatePhone = (phone) => {
        const phonePattern = /^[0-9]{10}$/;
        const isValid = phonePattern.test(phone);
        if (!isValid) {
            setPhoneError('Please enter a valid 10-digit phone number.');
        } else {
            setPhoneError('');
        }
    };

    const handleImageChange = (e) => {

        setSelectedFile(e.target.files[0]);
        const selectedImage = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'];

        if (selectedImage && allowedTypes.includes(selectedImage.type)) {
            setFile(URL.createObjectURL(selectedImage));
        } else {
            CustomToast.error('Please select a PNG, JPG, SVG or JPEG file.');
        }

    };

    const handleCertificateImageChange = (e) => {

        setSelectedCertificateFile(e.target.files[0]);
        const selectedCertificateImage = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'];

        if (selectedCertificateImage && allowedTypes.includes(selectedCertificateImage.type)) {
            setCertificateFile(URL.createObjectURL(selectedCertificateImage));
        } else {
            CustomToast.error('Please select a PNG, JPG, SVG or JPEG file.');
        }

    };

    const handleClose = () => {
        onClose();
        window.scrollTo(0, 0);
    };

    const handleNext = () => {
        if (step === 1) {
            if (!org_name || !selectedOrgSize || !selectedSector || !org_url) {
                CustomToast.error("Please fill all required fields in Basic Information.");
                return;
            }
        } else if (step === 2) {
            if (!org_address || !selectedCity || !selectedState || !org_pincode) {
                CustomToast.error("Please fill all required fields in Address Information.");
                return;
            }
        } else if (step === 3) {
            if (!contact_name || !contact_email || !contact_mobile || !contact_designation) {
                CustomToast.error("Please fill all required fields in Contact Information.");
                return;
            }
        } else if (step === 4) {
            if (!contract_start_date || !contract_end_date) {
                CustomToast.error("Please fill all required fields in Contract Information.");
                return;
            }
        }
        setStep(step + 1);
    };

    const handlePrev = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };

    const handleSend = async (event) => {
        event.preventDefault();
        setLoader(true)
        const formData = new FormData();
        formData.append("org_name", org_name);
        formData.append("org_size", selectedOrgSize);
        formData.append("org_sector", selectedSector);
        formData.append("org_url", org_url);
        formData.append("org_address", org_address);
        formData.append("org_city", selectedCity);
        formData.append("org_state", selectedState);
        formData.append("org_pincode", org_pincode);
        formData.append("plan_id", selectedPlan);
        formData.append("contact_name", contact_name);
        formData.append("contact_email", contact_email);
        formData.append("contact_mobile", contact_mobile);
        formData.append("contact_designation", contact_designation);
        formData.append("contract_start_date", contract_start_date);
        formData.append("contract_end_date", contract_end_date);
        if (selectedFile) {
            formData.append("image", selectedFile, selectedFile.name);
        }

        if (selectedCertificateFile) {
            formData.append("org_logo", selectedCertificateFile, selectedCertificateFile.name);
        }

        // Always append entities, even if empty (to clear entities if all are removed)
        if (entities && entities.length > 0) {
            const commaSeparatedValues = entities.filter(entity => entity.trim() !== '').join(",");
            formData.append("entities", commaSeparatedValues);
        } else {
            // If no entities, send empty string to clear existing entities
            formData.append("entities", "");
        }
        
        // Always append branches, even if empty (to clear branches if all are removed)
        if (branches && branches.length > 0) {
            const commaSeparatedBranches = branches.filter(branch => branch.trim() !== '').join(",");
            formData.append("branches", commaSeparatedBranches);
        } else {
            // If no branches, send empty string to clear existing branches
            formData.append("branches", "");
        }

        const token = apiService.getAuthToken()
        await apiService.patchV1(`update-org/${orgData.org_id}`, formData, token)
            .then((response) => {
                console.log('Organization updated successfully:', response);
                setTimeout(() => {
                    window.location.reload(true);
                }, 1000);
                CustomToast.success('Organization was updated successfully.')
                handleClose();
                navigate("/organisation_details");
                setLoader(false);
            })
            .catch((e) => {
                CustomToast.error(e.message);
                setLoader(false);
            })
    }

    return (
        <>
            <div className='w-100' style={{ minHeight: '100vh' }}>
                <h3 className='font-weight-600 font-20 mb-4'>Edit Organisation</h3>

                {loader ? <Loader /> :
                    <form onSubmit={handleSend} className="needs-validation" noValidate>
                        {/* Stepper Progress Bar */}
                        <div className="card p-0 mb-4">
                            <div className="card-body pb-0 px-3">
                                <div className="d-flex justify-content-between align-items-center stepper">
                                    {[
                                        { number: 1, label: "Basic Information" },
                                        { number: 2, label: "Organisation Address" },
                                        { number: 3, label: "Primary Contact" },
                                        { number: 4, label: "Organisation Plan" },
                                    ].map((item, idx) => {
                                        const isCompleted = step > item.number;
                                        const isActive = step === item.number;

                                        return (
                                            <div key={idx} className={`d-flex align-items-center flex-fill pb-3 ${isCompleted ? "step-completed" : isActive ? "step-active" : ""
                                                                    }`}>
                                                {/* Circle + Text */}
                                                <div className="d-flex align-items-center flex-row">
                                                    <div
                                                        className={`step-circle mx-auto mb-2 me-2 ${isCompleted ? "completed" : isActive ? "active" : ""
                                                            }`}
                                                    >
                                                        {isCompleted ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                                                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                                            </svg>
                                                        ) : (
                                                            item.number
                                                        )}
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold">{item.label}</div>
                                                        <div className="text-muted small">Step-{item.number}</div>
                                                    </div>
                                                </div>

                                                {/* Line between steps */}
                                                {idx < 3 && <div className="step-line flex-grow-1"></div>}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className='d-flex flex-row justify-content-between gap-4 mb-3 mx-0'>
                            <div className="card col-9 p-lg-3 p-0">
                                <div className="card-body d-flex justify-content-between flex-column h-100">
                                    {/* Step 1 – Basic Information */}
                                    {step === 1 && (<>
                                        <div className='d-flex justify-content-between flex-column'>
                                            <h5 className="fw-bold mb-4 primary_color">Basic Information</h5>
                                            <div className='row mb-4'>
                                                <div className="col-lg-6 form-group mb-3">
                                                    <label className='fw-bold mb-2'>Org. Name*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder='Org. Name'
                                                        value={org_name}
                                                        name="org_name"
                                                        onChange={(event) => setOrgName(event.target.value)}
                                                        required />
                                                </div>
                                                <div className="col-lg-6 form-group mb-3">
                                                    <label className='fw-bold mb-2'>Org. Size*</label>
                                                    <CustomSelect
                                                        id="orgSizeSelect"
                                                        name="selectedOrgSize"
                                                        placeholder="Select"
                                                        value={selectedOrgSize}
                                                        options={orgSizeOptions}
                                                        onChange={handleOrgSizeChange}>
                                                    </CustomSelect>
                                                </div>
                                                <div className='col-lg-6 form-group mb-3'>
                                                    <label className='fw-bold mb-2'>Sector / Industry*</label>
                                                    <CustomSelect
                                                        id="sectorSelect"
                                                        name="selectedSector"
                                                        placeholder="Select"
                                                        value={selectedSector}
                                                        options={sectorOptions}
                                                        onChange={handleSectorChange}>
                                                    </CustomSelect>
                                                </div>
                                                <div className='col-lg-6 form-group mb-3'>
                                                    <label className='fw-bold mb-2'>Org. website*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder='Org. Website'
                                                        value={org_url}
                                                        name="org_url"
                                                        onChange={(e) => setOrgUrl(e.target.value)}
                                                        required />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='d-flex justify-content-between border-top mt-4'>
                                            <button type="button" className="btn btn-white border px-4 py-2 mt-4 rounded-pill" onClick={handleClose}>
                                                Cancel
                                            </button>
                                            <button type="button" className="btn btn-primary px-4 py-2 mt-4 rounded-pill" onClick={handleNext}>
                                                Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                            </button>
                                        </div>
                                    </>)}

                                    {/* Step 2 – Organization Address */}
                                    {step === 2 && (
                                        <div className='d-flex justify-content-between flex-column h-100'>
                                            <div>
                                                <h5 className="fw-bold primary_color mb-4">Organisation Address</h5>
                                                <div className='row mb-4'>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label htmlFor="citySelect" className='fw-bold mb-2'>Org. Address*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='Org. Address'
                                                            value={org_address}
                                                            name="org_address"
                                                            onChange={(e) => setOrgAddress(e.target.value)}
                                                            required />
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label htmlFor="citySelect" className='fw-bold mb-2'>City*</label>
                                                        <Select
                                                            options={citiesList}
                                                            value={selectedShowCity}
                                                            onInputChange={handleInputChange}
                                                            isLoading={isFetchingCities}
                                                            onChange={handleCityChange}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label htmlFor="stateSelect" className='fw-bold mb-2'>State*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='State'
                                                            value={selectedState}
                                                            onChange={(event) => setSelectedState(event.target.value)}
                                                            required readOnly
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label className='fw-bold mb-2'>Postal Code*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='xxx xxx'
                                                            value={org_pincode}
                                                            name="org_pincode"
                                                            onChange={(e) => setOrgPincode(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <h5 className='fw-bold form-label font-16 mt-4 mb-0'>Entities</h5>
                                                <div className='row mt-3 mb-4'>
                                                    <div className="col-lg-12 form-group mb-3">
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Add entity'
                                                                value={entityInput}
                                                                onChange={(event) => setEntityInput(event.target.value)}
                                                                onKeyPress={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        event.preventDefault();
                                                                        handleAddEntity();
                                                                    }
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary px-4 py-2 ms-3"
                                                                onClick={handleAddEntity}
                                                            >
                                                                Add
                                                            </button>                                                            
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 entities">
                                                        {console.log("parsed entities ==>", entities)}
                                                        {entities && entities.length > 0 && entities?.map((entity, index) => (
                                                            <div key={index} className="entity-tag d-inline-flex align-items-center btn-primary text-white px-2 py-1 me-2 mb-2">
                                                                <span className="me-2">{entity}</span>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close btn-close-white btn-sm"
                                                                    onClick={() => handleRemoveEntity(index)}
                                                                    aria-label={`Remove ${entity}`}
                                                                    title={`Remove ${entity}`}
                                                                    style={{ 
                                                                        fontSize: '8px',
                                                                        opacity: '0.8'
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                        {/* {(!entities || entities.length === 0) && (
                                                            <p className="text-muted fst-italic">No entities added yet. Add entities above.</p>
                                                        )} */}
                                                    </div>
                                                    
                                                </div>
                                                
                                                <h5 className='fw-bold form-label font-16 mt-4 mb-0'>Branches</h5>
                                                <div className='row mt-3 mb-4'>
                                                    <div className="col-lg-12 form-group mb-3">
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Add branch'
                                                                value={branchInput}
                                                                onChange={(event) => setBranchInput(event.target.value)}
                                                                onKeyPress={handleBranchKeyPress}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary px-4 py-2 ms-3"
                                                                onClick={handleAddBranch}
                                                            >
                                                                Add
                                                            </button>                                                            
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 branches">
                                                        {console.log("parsed branches ==>", branches)}
                                                        {branches && branches.length > 0 && branches?.map((branch, index) => (
                                                            <div key={index} className="entity-tag d-inline-flex align-items-center btn-primary text-white px-2 py-1 me-2 mb-2">
                                                                <span className="me-2">{branch}</span>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close btn-close-white btn-sm"
                                                                    onClick={() => handleRemoveBranch(index)}
                                                                    aria-label={`Remove ${branch}`}
                                                                    title={`Remove ${branch}`}
                                                                    style={{ 
                                                                        fontSize: '8px',
                                                                        opacity: '0.8'
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between border-top'>
                                                <button type="button" className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center" onClick={handlePrev}>
                                                    <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                </button>
                                                <button type="button" className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center" onClick={handleNext}>
                                                    Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Step 3 – Primary Contact */}
                                    {step === 3 && (
                                        <div className='d-flex justify-content-between flex-column h-100'>
                                            <div>
                                                <h5 className="fw-bold primary_color mb-4">Primary Contact</h5>
                                                <div className='row mb-4'>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label className='fw-bold mb-2'>Name*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='Name'
                                                            value={contact_name}
                                                            name="contact_name"
                                                            onChange={(e) => setContactName(e.target.value)}
                                                            required />
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label className='fw-bold mb-2'>Email*</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder='Email ID'
                                                            value={contact_email}
                                                            name="contact_email"
                                                            onChange={handleEmailChange}
                                                            required />
                                                        {emailError && <p className="error">{emailError}</p>}
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label className='fw-bold mb-2'>Mobile*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='xxxxx xxxxx'
                                                            value={contact_mobile}
                                                            name="contact_mobile"
                                                            onChange={handlePhoneChange}
                                                            required />
                                                        {phoneError && <p className="error">{phoneError}</p>}
                                                    </div>
                                                    <div className="col-lg-6 form-group mb-3">
                                                        <label className='fw-bold mb-2'>Designation*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder='Designation'
                                                            value={contact_designation}
                                                            name="contact_designation"
                                                            onChange={(e) => setContactDesignation(e.target.value)}
                                                            required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between border-top'>
                                                <button type="button" className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center" onClick={handlePrev}>
                                                    <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                </button>
                                                <button type="button" className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center" onClick={handleNext}>
                                                    Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Step 4 – Organization Plan */}
                                    {step === 4 && (
                                        <div className='d-flex justify-content-between flex-column h-100'>
                                            <div>
                                                <h5 className="fw-bold primary_color font-20">Organization Plan</h5>
                                                <div className='row'>
                                                    <div className="col-lg-12 px-0">
                                                        {isFetchingPlans ? (
                                                            <div className="d-flex justify-content-center">
                                                                <div className="spinner-border text-primary" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="plan-switches-container">
                                                                <div className="row g-3">
                                                                    {plansList.map((plan, index) => (
                                                                        <div key={plan.value} className="col-lg-6 col-md-6 col-12">
                                                                            <div className="form-check form-switch plan-switch-item">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="organizationPlan"
                                                                                    id={`plan-${plan.value}`}
                                                                                    checked={selectedShowPlan?.value === plan.value}
                                                                                    onChange={() => handlePlanChange(plan)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`plan-${plan.value}`}>
                                                                                    <div className="plan-info">
                                                                                        <span className="plan-name">{plan.label}</span>
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <h5 className="fw-bold primary_color font-20 mt-4">Contract Date</h5>
                                                <div className='row mt-3'>
                                                    <div className="col-lg-6">
                                                        <label className="form-label">Contract Start Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={dayjs(contract_start_date).format('YYYY-MM-DD')}
                                                            onChange={(e) => setContactStartDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label className="form-label">Contract End Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={dayjs(contract_end_date).format('YYYY-MM-DD')}
                                                            onChange={(e) => setContactEndDate(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='d-flex justify-content-between border-top'>
                                                <button type="button" className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center" onClick={handlePrev}>
                                                    <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                </button>
                                                <button type="submit" className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center">
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col p-0">
                                <div className="card mb-4">
                                    {/* Step 5 – Certificate Logo Upload */}
                                    {/* {step === 1 && ( */}
                                    <div className='card-body text-center'>
                                        <h5 className="fw-bold primary_color font-20 mx-auto">Organisation Logo</h5>
                                        <div className="form-group w-100 fw-regular mt-4">
                                            <label className='custom-image-upload org flex-column w-100 rounded-4' style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="file"
                                                    name="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    style={{ display: 'none' }}
                                                    id="imageUploadInput"
                                                />

                                                <div className='m-auto' style={{ maxHeight: '200px', maxWidth: '200px' }}>
                                                    {file ? (
                                                        <img
                                                            src={file}
                                                            className='w-100'
                                                            style={{ maxHeight: '200px', maxWidth: '200px', objectFit: 'contain' }}
                                                            alt="Uploaded preview"
                                                        />
                                                    ) : (
                                                        <>
                                                            <img src="/images/image-icon.svg" alt="camera icon" style={{ width: "50px", height: "50px" }} />
                                                            <p className='small fw-regular mt-2'>
                                                                Supported formats include JPG, PNG<br /> Max file size: 10MB.
                                                            </p>
                                                        </>
                                                    )}
                                                </div>

                                                {file && (
                                                    <div className='mt-auto align-self-end' style={{ position: "absolute", right: 0, top: "auto", bottom: 0 }}>
                                                        <img src="/images/add_org_logo.svg" alt="add logo" style={{ width: "40px", height: "40px" }} />
                                                    </div>
                                                )}
                                            </label>

                                        </div>
                                    </div>
                                    {/* )} */}
                                </div>
                                <div className="card">
                                    {/* Step 5 – Certificate Logo Upload */}
                                    {/* {step === 1 && ( */}
                                    <div className='card-body text-center'>
                                        <h5 className="fw-bold primary_color font-20 mx-auto">Certificate Logo Upload</h5>
                                        <div className="form-group w-100 mt-4">
                                            <label className="custom-image-upload org w-100 rounded-4" style={{ cursor: 'pointer' }}>
                                                {certificateFile && <div className="m-auto">
                                                    <img
                                                        src={certificateFile}
                                                        className="w-100"
                                                        // style={{ maxHeight: '200px', maxWidth: '200px', objectFit: 'contain' }}
                                                        alt="Certificate Preview"
                                                    />
                                                </div>}

                                                {/* Hidden input inside the label */}
                                                <input
                                                    accept="image/*"
                                                    name="certificateFile"
                                                    type="file"
                                                    onChange={handleCertificateImageChange}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>

                                            <p className="small mx-auto mt-2">
                                                Drag and drop an image here, or click to browse your files.
                                                Supported formats: JPG, PNG. Max file size: 10MB.
                                            </p>

                                            {/* Optional: This can stay or be removed since the label now handles the click */}
                                            <a className="img_upload fw-bold position-relative bottom-0 mx-auto" onClick={() => document.querySelector('input[name="certificateFile"]').click()} style={{ cursor: 'pointer' }}>
                                                Change Image
                                            </a>
                                        </div>

                                    </div>
                                    {/* )} */}
                                </div>
                            </div>
                        </div>
                    </form>
                }
            </div>

            <style jsx>{`
                .plan-switches-container {
                    margin-top: 12px;
                }

                .plan-switches-container .row {
                    margin: 0;
                }

                .plan-switches-container .col-lg-6,
                .plan-switches-container .col-md-6,
                .plan-switches-container .col-12 {
                    padding: 0 8px;
                }

                .plan-switch-item {
                     border: 1px solid #212529;
                     border-radius: 4px;
                     padding: 10px 10px 10px 20px;
                     transition: all 0.3s ease;
                     background-color: #ffffff;
                     cursor: pointer;
                     display: flex;
                     align-items: center;
                     flex-direction: row-reverse;
                     gap: 12px;
                     height: 100%;
                     width: 100%;
                }

               .plan-switch-item input[type="radio"]:after {
                  display: none;
                }

                .plan-switch-item .form-check-input {
                    width: 20px;
                    height: 20px;
                    margin-top: 2px;
                    cursor: pointer;
                    border: 2px solid #dee2e6;
                }

                .plan-switch-item .form-check-input:checked {
                    background-color: #0d6efd;
                    border-color: #0d6efd;
                }

                .plan-switch-item .form-check-label {
                    cursor: pointer;
                    flex: 1;
                    margin-bottom: 0;
                }

                .plan-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                .plan-name {
                    font-weight: 500;
                    font-size: 15px;
                    color: #212529;
                    line-height: 1.4;
                }

                @media (max-width: 768px) {
                    .plan-switches-container .col-lg-6,
                    .plan-switches-container .col-md-6 {
                        margin-bottom: 16px;
                    }

                    .plan-switches-container .col-lg-6,
                    .plan-switches-container .col-md-6,
                    .plan-switches-container .col-12 {
                        padding: 0 4px;
                    }

                    .plan-switch-item {
                        padding: 12px;
                    }

                    .plan-name {
                        font-size: 15px;
                    }

                    .plan-info small {
                        font-size: 13px;
                    }
                }

                @media (max-width: 576px) {
                    .plan-switches-container .row .col-lg-6,
                    .plan-switches-container .row .col-md-6 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }
            `}</style>
        </>
    );
};

export default EditOrgnisation;